/**
 * Computes the lost and effective personal allowance.
 *
 * @param {number} totalGrossIncome - The user's total gross income.
 * @param {string} configYear - The configuration year.
 * @returns {Object} - { lostAllowance, effectivePersonalAllowance }
 */
export const calculateLostPersonalAllowance = (totalGrossIncome, config) => {
  // Safety check for config
  if (!config || typeof config.PERSONAL_ALLOWANCE_THRESHOLD === 'undefined' || typeof config.PERSONAL_ALLOWANCE === 'undefined') {
    return { lostAllowance: 0, effectivePersonalAllowance: 0 };
  }
  
  if (totalGrossIncome <= config.PERSONAL_ALLOWANCE_THRESHOLD) {
    return { lostAllowance: 0, effectivePersonalAllowance: config.PERSONAL_ALLOWANCE };
  }
  
  const lostAllowance = Math.min(
    (totalGrossIncome - config.PERSONAL_ALLOWANCE_THRESHOLD) / 2,
    config.PERSONAL_ALLOWANCE
  );
  const effectivePersonalAllowance = Math.max(0, config.PERSONAL_ALLOWANCE - lostAllowance);
  
  return { lostAllowance, effectivePersonalAllowance };
};
